<div class="sidebar light [&.light]:bg-gray-200 bg-light border-e border-e-white-200 light:border-e-white-100 fixed z-20 hidden lg:flex flex-col items-stretch shrink-0"
	style=" height: 100vh;background-color: #4e54c8;">
	<!-- Sidebar Header -->
	<div class="sidebar-header hidden lg:flex items-center justify-center px-2 shrink-0 text-gray-800 rounded-tr-2xl"
		id="sidebar_header">
		<a class="light:block mt-10">
			<img class="default-logo min-h-[22px] h-22"
				src="https://healthforcehub.com/wp-content/uploads/2024/04/final-logo-footer.png" />
			<img class="small-logo min-h-[22px] max-h-[32px] max-w-none" src="assets/media/app/final-icon-512.png" />
		</a>
	</div>
	<!-- Sidebar Toggle Button -->
	<button
		class="btn btn-icon btn-icon-md size-[30px] rounded-full border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-600 hover:text-gray-800 toggle absolute left-full top-[50px] -translate-x-2/4 shadow-sm"
		data-toggle="body" data-toggle-class="sidebar-collapse" id="sidebar_toggle">
		<i class="ki-filled ki-black-left-line toggle-active:rotate-180 transition-all duration-300"></i>
	</button>

	<!-- Sidebar Content -->
	<div class="sidebar-content flex grow shrink-0 py-5 pr-2 text-white" id="sidebar_content">
		<div class="scrollable-y-hover grow shrink-0 flex pl-2 lg:pl-5 pr-1 lg:pr-3" data-scrollable="true"
			data-scrollable-dependencies="#sidebar_header" data-scrollable-height="auto" data-scrollable-offset="0px"
			data-scrollable-wrappers="#sidebar_content" id="sidebar_scrollable">
			<div class="menu flex flex-col grow gap-2" data-menu="true" data-menu-accordion-expand-all="false"
				id="sidebar_menu">
				<!-- Menu Heading -->
				<div class="menu-item pt-4 pb-2 mt-10">
					<span class="menu-heading uppercase pl-4 pr-4 text-base font-bold text-gray-100 tracking-wider">
						Menu
					</span>
				</div>
				<!-- Dynamic Menu Items -->
				<div *ngFor="let menu of parentMenus; trackBy: trackByMenuId" class="menu-item"
					[attr.data-menu-item-toggle]="hasChildren(menu.menuId) ? 'accordion' : null"
					data-menu-item-trigger="click">

					<!-- ===================== -->
					<!-- MENU WITHOUT CHILDREN -->
					<!-- ===================== -->
					<div *ngIf="!hasChildren(menu.menuId)"
						class="menu-link flex items-center grow cursor-pointer border border-transparent gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200"
						tabindex="0" [routerLink]="menu.routeUrl">

						<span class="menu-icon items-start w-7" [innerHTML]="menu.iconClass"></span>

						<span class="menu-title text-base font-semibold text-gray-100
								menu-item-active:text-primary menu-link-hover:text-gray-700">
							{{ menu.menuText }}
						</span>
					</div>

					<!-- =================== -->
					<!-- MENU WITH CHILDREN  -->
					<!-- =================== -->
					<ng-container *ngIf="hasChildren(menu.menuId)">
						<div class="menu-link flex items-center grow cursor-pointer border border-transparent gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200"
							tabindex="0">

							<span class="menu-icon items-start w-7" [innerHTML]="menu.iconClass"></span>

							<span class="menu-title text-base font-semibold text-gray-100
								menu-item-active:text-primary menu-link-hover:text-gray-700">
								{{ menu.menuText }}
							</span>

							<span class="menu-arrow text-gray-100 menu-link-hover:text-gray-700 w-6 shrink-0 ml-auto">
								<i class="ki-filled ki-plus text-sm menu-item-show:hidden"></i>
								<i class="ki-filled ki-minus text-sm hidden menu-item-show:inline-flex"></i>
							</span>
						</div>

						<!-- CHILD MENUS -->
						<div class="menu-accordion gap-2 pl-4 relative
								before:absolute before:left-6 before:top-0 before:bottom-0
								before:border-l before:border-gray-600">

							<ng-container *ngFor="let child of getChildren(menu.menuId); trackBy: trackByMenuId">
								<div class="menu-item" [routerLink]="child.routeUrl"
									*ngIf="!child.routeUrl?.includes('worldnet-report') || isWorldNetClient">

									<a class="menu-link flex items-center grow cursor-pointer border border-transparent
									gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200" tabindex="0">

										<span class="menu-bullet flex w-2 relative
										before:absolute before:w-2 before:h-2 before:rounded-full
										menu-item-active:before:bg-primary
										menu-item-hover:before:bg-primary">
										</span>

										<span class="menu-title text-sm font-medium text-gray-100
										menu-item-active:text-primary menu-link-hover:text-gray-700">
											{{ child.menuText }}
										</span>

									</a>
								</div>
							</ng-container>
						</div>
					</ng-container>

				</div>



			</div>
		</div>
	</div>
</div>

<!-- MobileScreen SideBar Start-->

<div class="sidebar light [&.light]:bg-gray-200 bg-light border-e border-e-white-200 light:border-e-white-100
  fixed inset-y-0 left-0 z-30 flex lg:hidden flex-col items-stretch shrink-0"
	style="height: 100vh; background-color: #4e54c8;" id="mobile_sidebar">

	<!-- Sidebar Header -->
	<div class="sidebar-header flex items-center justify-center px-2 shrink-0 text-gray-800">
		<a class="mt-6">
			<img class="default-logo min-h-[22px] h-18"
				src="https://healthforcehub.com/wp-content/uploads/2024/04/final-logo-footer.png" />
		</a>
	</div>

	<!-- Sidebar Content -->
	<!-- MobileScreen SideBar Start-->
	<div class="sidebar light [&.light]:bg-gray-200 bg-light border-e border-e-white-200 light:border-e-white-100
  fixed inset-y-0 left-0 z-30 flex lg:hidden flex-col items-stretch shrink-0"
		style="height: 100vh; background-color: #4e54c8;" id="mobile_sidebar">

		<!-- Sidebar Header -->
		<div class="sidebar-header flex items-center justify-center px-2 shrink-0 text-gray-800"
			id="mobile_sidebar_header">
			<a class="mt-6">
				<img class="default-logo min-h-[22px] h-18"
					src="https://healthforcehub.com/wp-content/uploads/2024/04/final-logo-footer.png" />
			</a>
		</div>

		<!-- Sidebar Content -->
		<div class="sidebar-content flex flex-col grow overflow-hidden py-5 pr-2 text-white"
			id="mobile_sidebar_content">

			<!-- Scrollable Wrapper ¡ª Native scroll only, no KTMenu JS -->
			<div class="flex flex-col pl-2 pr-1" id="mobile_sidebar_scrollable"
				style="flex: 1 1 0; overflow-y: auto; overflow-x: hidden; -webkit-overflow-scrolling: touch; min-height: 0;scrollbar-width: thin; scrollbar-color: rgba(255,255,255,0.3) transparent;">

				<div class="menu flex flex-col gap-2" data-menu="true" data-menu-accordion-expand-all="false"
					id="mobile_sidebar_menu">

					<!-- Menu Heading -->
					<div class="menu-item pt-4 pb-2">
						<span class="menu-heading uppercase pl-4 pr-4 text-base font-bold text-gray-100 tracking-wider">
							Menu
						</span>
					</div>

					<!-- Dynamic Parent Menu Rendering -->
				<div *ngFor="let menu of parentMenus; trackBy: trackByMenuId" class="menu-item"
						[attr.data-menu-item-toggle]="hasChildren(menu.menuId) ? 'accordion' : null"
						data-menu-item-trigger="click">

						<!-- MENU WITHOUT CHILDREN -->
						<div *ngIf="!hasChildren(menu.menuId)"
							class="menu-link flex items-center grow cursor-pointer border border-transparent gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200"
							tabindex="0" [routerLink]="menu.routeUrl">

							<span class="menu-icon items-start w-7" [innerHTML]="menu.safeIcon"></span>

							<span class="menu-title text-base font-semibold text-gray-100
                menu-item-active:text-primary menu-link-hover:text-gray-700">
								{{ menu.menuText }}
							</span>
						</div>

						<!-- MENU WITH CHILDREN -->
						<ng-container *ngIf="hasChildren(menu.menuId)">
							<div class="menu-link flex items-center grow cursor-pointer border border-transparent gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200"
								tabindex="0">

								<span class="menu-icon items-start w-7" [innerHTML]="menu.safeIcon"></span>

								<span class="menu-title text-base font-semibold text-gray-100
                menu-item-active:text-primary menu-link-hover:text-gray-700">
									{{ menu.menuText }}
								</span>

								<span
									class="menu-arrow text-gray-100 menu-link-hover:text-gray-700 w-6 shrink-0 ml-auto">
									<i class="ki-filled ki-plus text-sm menu-item-show:hidden"></i>
									<i class="ki-filled ki-minus text-sm hidden menu-item-show:inline-flex"></i>
								</span>
							</div>

							<!-- CHILD MENUS -->
							<div class="menu-accordion gap-2 pl-4 relative
                before:absolute before:left-6 before:top-0 before:bottom-0
                before:border-l before:border-gray-600">

							<ng-container *ngFor="let child of getChildren(menu.menuId); trackBy: trackByMenuId">
									<div class="menu-item" [routerLink]="child.routeUrl"
										*ngIf="!child.routeUrl?.includes('worldnet-report') || isWorldNetClient">

										<a class="menu-link flex items-center grow cursor-pointer border border-transparent
                  gap-4 px-2 py-3 rounded-md hover:bg-gray-100 transition duration-200" tabindex="0">

											<span class="menu-bullet flex w-2 relative
                    before:absolute before:w-2 before:h-2 before:rounded-full
                    menu-item-active:before:bg-primary
                    menu-item-hover:before:bg-primary">
											</span>

											<span class="menu-title text-sm font-medium text-gray-100
                    menu-item-active:text-primary menu-link-hover:text-gray-700">
												{{ child.menuText }}
											</span>

										</a>
									</div>
								</ng-container>
							</div>
						</ng-container>

					</div>

				</div>
			</div>
		</div>
	</div>
	<!-- MobileScreen SideBar End-->


	<!-- MobileScreen SideBar End-->